import { CustomersTemplate } from "@/components/Templates";
import { useCustomersPage } from "@/hooks/useCustomersPage";

export function CustomersPage() {
  const customersPage = useCustomersPage();

  return <CustomersTemplate {...customersPage} />;
}
